import React from "react";
import moment from "moment";
import { SaveNewsView } from "./SaveNewsView";

const NewsCard = ({
  newsArticle,
  handleSaveUnsaveArticle,
  handleShareNewsArticle,
  redirectUserToNews,
  fromDetail,
  hideSave,
}) => {
  return (
    <div className="home-card news-card">
      {newsArticle.photo_url && (
        <div
          className="news-image"
          style={{
            backgroundImage: `url('${newsArticle.photo_url}')`,
          }}
          onClick={() => redirectUserToNews(newsArticle, "News Image")}
        >
          {newsArticle.news_label && (
            <span className="news_label">{`${newsArticle.news_label}`}</span>
          )}
        </div>
      )}

      <div
        className={`${
          newsArticle.photo_url
            ? "news-detail-wrapper"
            : "news-detail-wrapper mt-15"
        }`}
      >
        <div className="d-flex pl-20 prx-20 space-between">
          <div className="news-source-name mb-8">{newsArticle.source_name}</div>
          {/* 
            {!fromDetail && !hideSave && (
              <SaveNewsView
              newsArticle={newsArticle}
              handleSaveUnsaveArticle={handleSaveUnsaveArticle}
            />
            )} */}
        </div>
        <div
          className="news-heading"
          onClick={() => redirectUserToNews(newsArticle, "News Headline")}
        >
          {newsArticle.title}
        </div>

        <div className="news-text-wrap">
          <div className={`news-text ${fromDetail ? "show-full-text" : ""}`}>
            {newsArticle.news_text}
          </div>
        </div>
        {/* news source details :Start */}
        <div className="news-source-details">
          <div className="news-date">
            {moment(newsArticle.news_date).format("DD MMM")}
          </div>
        </div>
        {/* news source details :End */}
        {/* <a href="#" onClick={e => handleShareNewsArticle(newsArticle, e)}>
            <RiShareForwardLine
              size={"24px"}
              className="vertical-middle icon-color-grey"
            />
            <span className="text">Share</span>
          </a> */}
      </div>
    </div>
  );
};

export default NewsCard;
